import * as S from './styled'

import { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { t } from 'i18next'
import api from '@/core/services/api'
import { useAlert } from '@/core/context/useWindow'

export default function GamePlay() {
  const { vendor, id, currency } = useParams()
  const navigate = useNavigate()
  const { openAlert } = useAlert()
  const [link, setLink] = useState('')

  useEffect(() => {
    if (!id || !vendor || !currency) return
    api.get('/user-game/game-launch-link', {
      params: { game_id: id, vendor, currency }
    })
      .then((res) => {
        const content = res.data?.content
        const gameLink = content?.link || content
        if (gameLink) setLink(gameLink)
      })
      .catch((err) => {
        console.error(err)
        // 점검중 안내(게임사 우선) — 그 외는 기존 메시지
        const code = err.response?.data?.errors?.[0]?.msg?.code
        const msg = code === 'G011' ? t('bet_reject.vendor_maintenance')
          : code === 'G010' ? t('bet_reject.game_maintenance')
            : (err.response?.data?.message || t('error.unknown'))
        // gold 알림 상자로 안내하고, 확인을 누르면 이전 화면으로
        openAlert({ message: msg, Func: () => navigate(-1) })
      })
  }, [id, vendor, currency])

  // PC 화면은 최소 폭(1440px)이라 좁은 창에선 게임 아래에 가로 스크롤바가 생긴다 — 게임 화면에 있는 동안만 문서 스크롤을 막는다
  useEffect(() => {
    const html = document.documentElement
    const prev = html.style.overflow
    html.style.overflow = 'hidden'
    return () => { html.style.overflow = prev }
  }, [])

  // Gold PC 게임 화면은 머리줄·버튼 줄(새 창·전체화면·뒤로가기) 없이 게임만 화면 가득(2026-10-23 요청)
  return (
    <S.Wrap>
      {link && (
        <S.GameFrame
          src={link}
          allowFullScreen
          allow="autoplay; fullscreen"
        />
      )}
    </S.Wrap>
  )
}
